import { UiControllerApi } from "./generated/api"

export interface ErrorReporter {
    (name: string, error: Error, refId?: string): Promise<void>
}

export const consoleErrorReporter = (): ErrorReporter => async (name: string, error: Error, refId?: string) => {
    if (error instanceof Response) {
            const body = await error.text();
            const status = error.status;
            console.log({ name: name, status: status, message: body, refId: refId ?? '' })
        } else {
            console.log({ name: name, message: error.message ?? '', refId: refId ?? '' })
        }
    return Promise.resolve()
}

